webpackJsonp(['themes/modern'],{

/***/ "themes/modern":
/***/ function(module, exports, __webpack_require__) {

	/*
	 * mill-basic-theme - index.js
	 * Copyright(c) 2016 xeodou <xeodou@gmail.com>
	 * MIT Licensed
	 */
	
	'use strict'
	
	module.exports = {
	  articleDetail: __webpack_require__("themes/modern/1"),
	  articleListItem: __webpack_require__("themes/modern/2"),
	  sideBar: __webpack_require__("themes/modern/3"),
	  tag: __webpack_require__("themes/modern/4"),
	  shareButton: __webpack_require__("themes/modern/5")
	}


/***/ },

/***/ "themes/modern/1":
/***/ function(module, exports) {

	"use strict;"
	
	module.exports = function (React, props) {
	  var post = props.post,
	      Tag = props.Tag,
	      user = props.user,
	      Link = props.Link,
	      ShareButton = props.ShareButton,
	      url = props.url;
	  return React.createElement(
	    "div",
	    { className: "mill-detail" },
	    React.createElement(
	      "h1",
	      { className: "post-title" },
	      post.title
	    ),
	    React.createElement(
	      "div",
	      { className: "mill-detail-content" },
	      React.createElement(
	        "section",
	        { className: "post-meta" },
	        React.createElement(
	          "span",
	          { className: "post-time" },
	          React.createElement("i", { className: "fa fa-calendar" }),
	          React.createElement(
	            "time",
	            { className: "fulldate" },
	            post.createdAt ? post.createdAt.toDateString() : ""
	          )
	        ),
	        React.createElement(Tag, { tags: post.tags })
	      ),
	      React.createElement("div", { dangerouslySetInnerHTML: { __html: post.html } }),
	      React.createElement(
	        "footer",
	        { className: "post-footer" },
	        React.createElement(
	          "figure",
	          { className: "author-image" },
	          React.createElement(
	            "a",
	            { className: "img", href: user.ghLink, style: { backgroundImage: "url(" + user.avatar + "&s=120)" } },
	            React.createElement(
	              "span",
	              { className: "hidden" },
	              user.login
	            )
	          )
	        ),
	        React.createElement(
	          "section",
	          { className: "author" },
	          React.createElement(
	            "h4",
	            null,
	            React.createElement(
	              Link,
	              { to: "/", query: { author: user.login } },
	              user.login
	            )
	          ),
	          React.createElement(
	            "p",
	            null,
	            "Read",
	            React.createElement(
	              Link,
	              { to: "/", query: { author: user.login } },
	              "more posts"
	            ),
	            " by this author."
	          ),
	          React.createElement(
	            "div",
	            { className: "author-meta" },
	            React.createElement(
	              "i",
	              { className: "fa fa-link" },
	              React.createElement(
	                "a",
	                { href: post.ghLink },
	                post.ghLink
	              )
	            )
	          )
	        ),
	        React.createElement(
	          "section",
	          { className: "share" },
	          React.createElement(
	            "h4",
	            null,
	            "Share this post"
	          ),
	          React.createElement(
	            "div",
	            { className: "share-icons" },
	            ["twitter", "facebook", "google-plus", "weibo"].map(function (i, j) {
	              return React.createElement(ShareButton, { key: j, publisher: i, url: url, content: post.title });
	            })
	          )
	        )
	      )
	    )
	  );
	};

/***/ },

/***/ "themes/modern/2":
/***/ function(module, exports) {

	'use strict;'
	
	module.exports = function (React, props) {
	  var Link = props.Link,
	      post = props.post,
	      Tag = props.Tag;
	  return React.createElement(
	    'article',
	    { className: 'post' },
	    React.createElement(
	      'header',
	      { className: 'post-head' },
	      React.createElement(
	        'h1',
	        { className: 'post-title' },
	        React.createElement(
	          Link,
	          { to: '/post/' + post.id },
	          post.title
	        )
	      )
	    ),
	    React.createElement(
	      'div',
	      { className: 'post-preview' },
	      React.createElement(
	        'aside',
	        { className: 'col-aside' },
	        React.createElement(
	          'span',
	          { className: 'post-meta' },
	          React.createElement('i', { className: 'fa fa-calendar' }),
	          React.createElement(
	            'time',
	            { className: 'post-item-time', dateTime: post.createdAt.toJSON() },
	            post.createdAt.toDateString()
	          ),
	          React.createElement(Tag, { tags: post.tags })
	        )
	      ),
	      React.createElement(
	        'section',
	        { className: 'post-excerpt' },
	        React.createElement(
	          'p',
	          null,
	          post.sumary
	        ),
	        React.createElement(
	          Link,
	          { className: 'btn', to: '/post/' + post.id },
	          'Read More'
	        )
	      )
	    )
	  );
	};

/***/ },

/***/ "themes/modern/3":
/***/ function(module, exports) {

	"use strict;"
	
	module.exports = function (React, props) {
	  var logo = props.logo,
	      title = props.title;
	  return React.createElement(
	    "header",
	    null,
	    React.createElement("div", { id: "header-overlay", style: { backgroundImage: "url(https://cloud.githubusercontent.com/assets/914595/14740387/201976da-08c1-11e6-8779-2518801361cb.jpg)" } }),
	    React.createElement(
	      "div",
	      { id: "overlay" },
	      React.createElement(
	        "div",
	        { className: "logo" },
	        React.createElement(
	          "a",
	          null,
	          React.createElement("img", { src: logo, alt: title || '' })
	        ),
	        title
	      ),
	      React.createElement(
	        "div",
	        { className: "socials" },
	        React.createElement(
	          "div",
	          null,
	          React.createElement(
	            "a",
	            { href: "#/" },
	            React.createElement("i", { className: "fa fa-twitter", "aria-hidden": "true" })
	          )
	        ),
	        React.createElement(
	          "div",
	          null,
	          React.createElement(
	            "a",
	            { href: "https://github.com/graffie" },
	            React.createElement("i", { className: "fa fa-github", "aria-hidden": "true" })
	          )
	        ),
	        React.createElement(
	          "div",
	          null,
	          React.createElement(
	            "a",
	            { href: "#/" },
	            React.createElement("i", { className: "fa fa-instagram", "aria-hidden": "true" })
	          )
	        ),
	        React.createElement(
	          "div",
	          null,
	          React.createElement(
	            "a",
	            { href: "#/" },
	            React.createElement("i", { className: "fa fa-medium", "aria-hidden": "true" })
	          )
	        )
	      )
	    ),
	    React.createElement(
	      "span",
	      { id: "more" },
	      React.createElement("i", { className: "fa fa-angle-double-down", "aria-hidden": "true" })
	    )
	  );
	};

/***/ },

/***/ "themes/modern/4":
/***/ function(module, exports) {

	'use strict;'
	
	module.exports = function (React, props) {
	  var tags = props.tags,
	      Link = props.Link;
	  return React.createElement(
	    'p',
	    { className: 'post-item-tags' },
	    React.createElement('i', { className: 'fa fa-tags' }),
	    tags.map(function (t, i) {
	      var comma = i !== tags.length - 1 ? React.createElement(
	        'span',
	        null,
	        ', '
	      ) : '';
	      return React.createElement(
	        Link,
	        { key: i, to: '/', query: { tag: t } },
	        t,
	        comma
	      );
	    })
	  );
	};

/***/ },

/***/ "themes/modern/5":
/***/ function(module, exports) {

	"use strict;"
	
	module.exports = function (React, props) {
	  var className = props.className,
	      link = props.link,
	      onClick = props.onClick,
	      publisher = props.publisher;
	  return React.createElement(
	    "a",
	    { className: className, href: link, onClick: onClick },
	    React.createElement(
	      "span",
	      { className: "hidden" },
	      publisher
	    )
	  );
	};

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** modern.js
 **/